import { memo } from "react";

const HamburgerMenuIcon: React.FC<{ customClassName?: string }> = ({
  customClassName,
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={customClassName} width="24.534" height="17.356" viewBox="0 0 24.534 17.356">
    <g transform="translate(-3 -7.5)">
      <path id="Path_100" data-name="Path 100" d="M4.5,18H26.034" transform="translate(0 -1.822)" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
      <path id="Path_101" data-name="Path 101" d="M4.5,9H26.034" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
      <path id="Path_102" data-name="Path 102" d="M4.5,27H26.034" transform="translate(0 -3.644)" fill="none" stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" />
    </g>
  </svg>
)

export default memo(HamburgerMenuIcon);
